import { render, staticRenderFns } from "./BoardEmptyLink.vue?vue&type=template&id=5432d135&scoped=true&"
import script from "./BoardEmptyLink.vue?vue&type=script&lang=js&"
export * from "./BoardEmptyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432d135",
  null
  
)

export default component.exports